import { render, staticRenderFns } from "./SystemBusinessRisksTable.vue?vue&type=template&id=4ff84e58&"
import script from "./SystemBusinessRisksTable.vue?vue&type=script&lang=js&"
export * from "./SystemBusinessRisksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports